<div class="h-screen flex flex-column bg-cover layout-container" [ngClass]="containerClass">
  <app-topbar></app-topbar>

  <div class="align-self-center mt-auto mb-auto">
    <div class="flex justify-content-center">
      <img src="assets/layout/images/pages/accessDenied.png" alt="" />
    </div>
    <div class="flex flex-column gap-2 align-items-center">
      <!-- <h1 class="m-0 text-bluegray-700 font-semibold">ACCESS DENIED!</h1> -->
      <div
        class="not-permitted-page text-lg flex flex-column justify-content-center align-items-center text-center p-5 border-round">
        <!-- PrimeIcons lock icon -->

        <!-- Title Section -->
        <p class="font-bold text-2xl text-danger mb-4">OOPS!! Permission Denied</p>

        <!-- Message Section -->
        <p class="text-lg mb-3">
          Looks like you don't have enough permission to view the content for this module.
        </p>

        <!-- Instruction Section -->
        <p class="text-lg">
          Please contact either
          <span class="font-bold">County Senior Official</span>
          or <span class="font-bold">Clearbasin Support Team</span> to get it handled.
        </p>
      </div>
    </div>
    <div class="flex justify-content-center mt-3">
      <button pButton pRipple type="button" label="BACK TO MANAGE PORTALS" [routerLink]="['/manage-portals']"
        class="p-button-text bg-primary text-white"></button>
    </div>
  </div>
</div>